// Messages for operator/CustomerDetail (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.customer_detail.head': '{name} — Customer',
  'operator.customer_detail.back': 'Back to customers',
  'operator.customer_detail.badge': 'Customer',
  'operator.customer_detail.representative': 'Representative',
  'operator.customer_detail.portal_users_summary': '{count} staff',
  'operator.customer_detail.impersonate': 'Impersonate',
  'operator.customer_detail.edit': 'Edit',
  'operator.customer_detail.link.invite_reset': 'Invite/reset link for',
  'operator.customer_detail.link.share_hint': "— share it if email isn't set up yet:",
  'operator.customer_detail.link.copy': 'Copy',
  'operator.customer_detail.link.dismiss': 'Dismiss',
  'operator.customer_detail.kpi.shipments': 'Shipments',
  'operator.customer_detail.kpi.open_quotes': 'Open quotes',
  'operator.customer_detail.kpi.portal_users': 'Staff',
  'operator.customer_detail.kpi.api_calls': 'API calls (mo)',
  'operator.customer_detail.tab.access': 'API access',
  'operator.customer_detail.tab.users': 'Staff',
  'operator.customer_detail.access.title': 'Customer API access',
  'operator.customer_detail.access.sub':
    "Govern this customer's read + limited-write API & webhooks",
  'operator.customer_detail.access.blocked_pre': 'API access is',
  'operator.customer_detail.access.blocked_word': 'blocked',
  'operator.customer_detail.access.blocked_post': "— all of this customer's keys return",
  'operator.customer_detail.access.blocked_until': 'until you unblock.',
  'operator.customer_detail.access.enable_title': 'Enable customer API',
  'operator.customer_detail.access.enable_sub':
    'Lets this customer create keys & call the API for their own data.',
  'operator.customer_detail.access.enable_aria': 'Enable customer API',
  'operator.customer_detail.access.limit_min': 'Rate limit — per minute',
  'operator.customer_detail.access.limit_min_aria': 'Rate limit per minute',
  'operator.customer_detail.access.limit_day': 'Rate limit — per day',
  'operator.customer_detail.access.limit_day_aria': 'Rate limit per day',
  'operator.customer_detail.access.usage_today': 'Usage today',
  'operator.customer_detail.access.usage_default': 'default',
  'operator.customer_detail.access.unblock': 'Unblock API',
  'operator.customer_detail.access.block': 'Block API',
  'operator.customer_detail.access.save': 'Save changes',
  'operator.customer_detail.access.off':
    'API access is off. Enable it to issue keys, set rate limits, and let this customer call the API — and to show the Developers page in their portal.',
  'operator.customer_detail.keys.title': 'API keys ({count})',
  'operator.customer_detail.keys.empty': 'No keys created by this customer.',
  'operator.customer_detail.keys.no_scopes': 'no scopes',
  'operator.customer_detail.keys.revoked': 'Revoked',
  'operator.customer_detail.keys.revoke': 'Revoke',
  'operator.customer_detail.keys.confirm_revoke': 'Revoke this API key?',
  'operator.customer_detail.webhooks.title': 'Webhooks ({count})',
  'operator.customer_detail.webhooks.empty': 'No webhooks registered.',
  'operator.customer_detail.webhooks.disable': 'Disable',
  'operator.customer_detail.webhooks.enable': 'Enable',
  'operator.customer_detail.users.title': 'Staff',
  'operator.customer_detail.users.sub':
    'People who can sign in to the customer portal for this company',
  'operator.customer_detail.users.invite': 'Invite user',
  'operator.customer_detail.users.empty':
    'No portal users yet — invite someone so they can sign in.',
  'operator.customer_detail.users.deactivated': 'Deactivated ({count})',
  'operator.customer_detail.users.role_aria': 'Role for {email}',
  'operator.customer_detail.users.role.member': 'Member',
  'operator.customer_detail.users.role.company_admin': 'Company admin',
  'operator.customer_detail.users.resend_invite': 'Resend invite',
  'operator.customer_detail.users.reset_password': 'Reset password',
  'operator.customer_detail.users.disable': 'Disable',
  'operator.customer_detail.users.enable': 'Enable',
  'operator.customer_detail.users.remove_aria': 'Remove {email}',
  'operator.customer_detail.users.confirm_remove': 'Remove {email} from this customer?',
  'operator.customer_detail.limit.account_default': 'Account default',
  'operator.customer_detail.limit.unlimited': 'Unlimited',
  'operator.customer_detail.limit.per_min': '{count} req/min',
  'operator.customer_detail.limit.per_day': '{count}/day',
}

export const zhTW = {
  'operator.customer_detail.head': '{name} — 客戶',
  'operator.customer_detail.back': '返回客戶列表',
  'operator.customer_detail.badge': '客戶',
  'operator.customer_detail.representative': '代表',
  'operator.customer_detail.portal_users_summary': '{count} 位員工',
  'operator.customer_detail.impersonate': '模擬登入',
  'operator.customer_detail.edit': '編輯',
  'operator.customer_detail.link.invite_reset': '邀請／重設連結，對象：',
  'operator.customer_detail.link.share_hint': '— 若電子郵件尚未設定，請直接分享此連結：',
  'operator.customer_detail.link.copy': '複製',
  'operator.customer_detail.link.dismiss': '關閉',
  'operator.customer_detail.kpi.shipments': '貨件',
  'operator.customer_detail.kpi.open_quotes': '未結報價',
  'operator.customer_detail.kpi.portal_users': '員工',
  'operator.customer_detail.kpi.api_calls': 'API 呼叫（本月）',
  'operator.customer_detail.tab.access': 'API 存取',
  'operator.customer_detail.tab.users': '員工',
  'operator.customer_detail.access.title': '客戶 API 存取',
  'operator.customer_detail.access.sub': '管理此客戶的讀取 + 有限寫入 API 與 webhook',
  'operator.customer_detail.access.blocked_pre': 'API 存取已',
  'operator.customer_detail.access.blocked_word': '封鎖',
  'operator.customer_detail.access.blocked_post': '— 此客戶的所有金鑰將回傳',
  'operator.customer_detail.access.blocked_until': '直到您解除封鎖為止。',
  'operator.customer_detail.access.enable_title': '啟用客戶 API',
  'operator.customer_detail.access.enable_sub': '讓此客戶可建立金鑰並呼叫 API 以存取自己的資料。',
  'operator.customer_detail.access.enable_aria': '啟用客戶 API',
  'operator.customer_detail.access.limit_min': '速率限制 — 每分鐘',
  'operator.customer_detail.access.limit_min_aria': '每分鐘速率限制',
  'operator.customer_detail.access.limit_day': '速率限制 — 每天',
  'operator.customer_detail.access.limit_day_aria': '每天速率限制',
  'operator.customer_detail.access.usage_today': '今日用量',
  'operator.customer_detail.access.usage_default': '預設',
  'operator.customer_detail.access.unblock': '解除封鎖 API',
  'operator.customer_detail.access.block': '封鎖 API',
  'operator.customer_detail.access.save': '儲存變更',
  'operator.customer_detail.access.off':
    'API 存取已關閉。啟用後即可建立金鑰、設定速率限制、讓此客戶呼叫 API，並在其入口網站顯示「開發者」頁面。',
  'operator.customer_detail.keys.title': 'API 金鑰（{count}）',
  'operator.customer_detail.keys.empty': '此客戶尚未建立任何金鑰。',
  'operator.customer_detail.keys.no_scopes': '無範圍',
  'operator.customer_detail.keys.revoked': '已撤銷',
  'operator.customer_detail.keys.revoke': '撤銷',
  'operator.customer_detail.keys.confirm_revoke': '要撤銷此 API 金鑰嗎？',
  'operator.customer_detail.webhooks.title': 'Webhook（{count}）',
  'operator.customer_detail.webhooks.empty': '尚未註冊任何 webhook。',
  'operator.customer_detail.webhooks.disable': '停用',
  'operator.customer_detail.webhooks.enable': '啟用',
  'operator.customer_detail.users.title': '員工',
  'operator.customer_detail.users.sub': '可登入此公司客戶入口的人員',
  'operator.customer_detail.users.invite': '邀請使用者',
  'operator.customer_detail.users.empty': '尚無入口使用者 — 邀請某人以便他們可以登入。',
  'operator.customer_detail.users.deactivated': '已停用（{count}）',
  'operator.customer_detail.users.role_aria': '{email} 的角色',
  'operator.customer_detail.users.role.member': '成員',
  'operator.customer_detail.users.role.company_admin': '公司管理員',
  'operator.customer_detail.users.resend_invite': '重新傳送邀請',
  'operator.customer_detail.users.reset_password': '重設密碼',
  'operator.customer_detail.users.disable': '停用',
  'operator.customer_detail.users.enable': '啟用',
  'operator.customer_detail.users.remove_aria': '移除 {email}',
  'operator.customer_detail.users.confirm_remove': '要將 {email} 從此客戶移除嗎？',
  'operator.customer_detail.limit.account_default': '帳戶預設',
  'operator.customer_detail.limit.unlimited': '無限制',
  'operator.customer_detail.limit.per_min': '{count} 次/分鐘',
  'operator.customer_detail.limit.per_day': '{count}/天',
}
